import { Stack } from '@mui/material'
import AutoComplete from './SecondaryMenu/AutoComplete'
import TextField from './SecondaryMenu/TextField'
import Button from './SecondaryMenu/Button'
import ButtonGroup from './SecondaryMenu/ButtonGroup'
import DateRangePicker from './SecondaryMenu/DateRangePicker'

export default function SecondaryMenu({ menuItems }: any) {
	const mapping: any = {
		textField: TextField,
		autoComplete: AutoComplete,
		button: Button,
		buttonGroup: ButtonGroup,
		dateRangePicker: DateRangePicker
	}

	return (
		<Stack spacing={1} direction='row'>
			{menuItems?.map(({ type, props, ...rest }: any) => {
				const MappedComponent = mapping[type]

				return <MappedComponent rest={rest} props={props}  />
			})}
		</Stack>
	)
}
